<template>
    <div id="app" class="flex flex-grow justify-center h-screen">
   <router-view/>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';


export default class App extends Vue {}
</script>

